import api from '@/lib/api/axios'

export interface VaultItem {
    id: number
    vaultId: string
    description: string
    region: string
    regionName: string
    operationalStatus: string
    buildAction: string | null
    buildStatus: string | null
    // Provisioning progress, from vw_VaultProvisioning — the vault's current request.
    correlationId?: string | null
    requestStatus?: string | null
    buildRequested?: string | null
    buildStage?: string | null
    buildStageNumber?: number | null
    buildStageCount?: number | null
    buildUpdated?: string | null
    buildError?: string | null
    customerId?: string | null
    regionAccountId?: string | null
    regionOperationalStatus?: string | null
    objectCount: number
    versionCount: number
    size: number
    retentionDays: number | null
    analytics: boolean
    created: string | null
}

export interface VaultRegion {
    code: string
    name: string
    city?: string | null
    country?: string | null
    locationId?: number | null
}

export interface ActiveScheduler {
    id: number
    schedulerId: string
    description: string
    hasPublicKey: boolean
}

export interface SetupSchedulerResponse {
    vaultConnectionToken: string
    vaultId: string
    vaultDescription: string
    schedulerId: string
    schedulerDescription: string
}

export const vaultsApi = {
    list: () =>
        api.get('/api/vaults'),

    create: (data: { description: string; region: string; retention?: number }) =>
        api.post('/api/vaults', data),

    update: (id: number, data: {
        description?: string
        analytics?: boolean
        retention?: number | null
    }) => api.put(`/api/vaults/${id}`, data),

    getRegions: () =>
        api.get('/api/vaults/regions'),

    getActiveSchedulers: () =>
        api.get('/api/vaults/active-schedulers'),

    setupScheduler: (vaultId: number, schedulerId: string) =>
        api.post(`/api/vaults/${vaultId}/setup-scheduler`, { schedulerId }),
}
